<template>
  <v-form
    ref="recallForm"
    v-model="valid"
    lazy-validation
  >
    <v-card>
      <v-card-title>
        <span class="headline">Add Recall for {{saleId}}</span>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-menu
              ref="menu1"
              v-model="datemenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Date"
                  hint="MM/DD/YYYY"
                  
                  prepend-inner-icon="event"
                  v-on="on"
                  outlined
                  dense
                  autocomplete="off"
                  :rules="[$validation.required]"
                  required
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="recall.date" no-title @input="datemenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              label="Trip Cost"
              prepend-inner-icon="$"
              v-model="recall.tripCost"
              :rules="[$validation.required]"
              dense
              required
              hide-details
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
          outlined
          class="my-5"
          label="Add Recall Reason"
          v-model="recall.reason"
          :rules="[$validation.required]"
          required
          hide-details
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" outlined @click="dismissRecall" :disabled="updating">Cancel</v-btn>
        <v-btn color="primary" @click="saveRecall" :loading="updating">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

export default {
  name: "RecallSales",
  props: {
    saleId: {
      default: null
    }
  },
  data: () => ({
    valid: true,

    datemenu: false,
    dateFormatted: '',
    recall: {
      date: "",
      reason: ""
    },
    updating: false
  }),
  watch: {
    recall:{
      handler() {
        this.dateFormatted = this.formatDate(this.recall.date);
      },
      deep: true
    }
  },
  methods: {
    formatDate (date) {
      return this.$date.simple(date);
    },
    async saveRecall() {
      this.updating = true;
      if (this.$refs.recallForm.validate()) {
        try {
          await this.$recallService.addRecall({
            saleId: this.saleId,
            ...this.recall,
          });
          this.$refs.recallForm.reset();
          this.$successResponse(null, 'toast', 'Recall added successfully!');
          this.$emit('close')
          this.$router.push("/sales")
        } catch (error) {
          this.$errorResponse(error);
        }
      }
      this.updating = false;
    },
    dismissRecall() {
      this.$emit('close')
    }
  }
};
</script>